import React, { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const ACCENT_MAP = {
  emerald: "border-emerald-400/50 bg-emerald-500/10 text-emerald-200 hover:bg-emerald-500/20",
  fuchsia: "border-fuchsia-400/50 bg-fuchsia-500/10 text-fuchsia-200 hover:bg-fuchsia-500/20",
  purple:  "border-purple-400/50 bg-purple-500/10 text-purple-200 hover:bg-purple-500/20",
  pink:    "border-pink-400/50 bg-pink-500/10 text-pink-200 hover:bg-pink-500/20",
};

/**
 * StripeCheckoutButton — starts a real Stripe Checkout session
 * against the backend and redirects the buyer. Handles anonymous +
 * authenticated flows (backend derives user_id from session cookie).
 */
export default function StripeCheckoutButton({
  lookupKey,
  label,
  testId,
  accent = "emerald",
  disabled = false,
  quantity = 1,
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const start = async () => {
    setBusy(true);
    setErr("");
    try {
      const r = await axios.post(
        `${API}/api/payments/checkout`,
        { lookup_key: lookupKey, origin_url: window.location.origin, quantity },
        { withCredentials: true },
      );
      if (r.data?.checkout_url) {
        window.location.href = r.data.checkout_url;
      } else {
        setErr("Checkout session missing URL.");
      }
    } catch (e) {
      const msg = e?.response?.data?.detail || e?.message || "Unable to start checkout.";
      setErr(String(msg));
    } finally {
      setBusy(false);
    }
  };

  const cls = ACCENT_MAP[accent] || ACCENT_MAP.emerald;
  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={start}
        disabled={disabled || busy}
        data-testid={testId || `stripe-checkout-${lookupKey}`}
        className={`w-full font-mono text-[11px] uppercase tracking-[0.2em] px-4 py-2.5 border ${cls} transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        {busy ? "STARTING_CHECKOUT…" : label}
      </button>
      {err && (
        <div className="mt-2 text-[11px] font-mono text-rose-300" data-testid={`stripe-checkout-error-${lookupKey}`}>
          {err}
        </div>
      )}
      <div className="mt-1 text-[10px] font-mono text-zinc-500 tracking-wide">
        SECURED_BY_STRIPE · TAXES_AUTO
      </div>
    </div>
  );
}
